import react from 'react';

('use strict');
Object.defineProperty(exports, '__esModule', {
  value: true,
});
var _react = _interopRequireDefault(react);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}
var Image = function Image(_ref) {
  var entityKey = _ref.entityKey,
    children = _ref.children,
    contentState = _ref.contentState;
  var _contentState$getEnti = contentState.getEntity(entityKey).getData(),
    src = _contentState$getEnti.src,
    alt = _contentState$getEnti.alt,
    title = _contentState$getEnti.title;
  return /*#__PURE__*/ _react.default.createElement(
    'span',
    null,
    children,
    /*#__PURE__*/ _react.default.createElement('img', {
      src: src,
      alt: alt,
      title: title,
    }),
  );
};
var _default = Image;
export default _default;
